export default __webpack_public_path__ + "static/media/75t.5c597011.jpg";